/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  ImportTimesheetEntriesMutationRequest,
  ImportTimesheetEntriesMutationResponse,
} from '../models/ImportTimesheetEntries.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  importTimesheetEntriesMutationResponseSchema,
  importTimesheetEntriesMutationRequestSchema,
} from '../zod/importTimesheetEntriesSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const importTimesheetEntriesMutationKey = () =>
  [{ url: '/api/entries/import' }] as const;

export type ImportTimesheetEntriesMutationKey = ReturnType<
  typeof importTimesheetEntriesMutationKey
>;

/**
 * {@link /api/entries/import}
 */
export async function importTimesheetEntries(
  data: ImportTimesheetEntriesMutationRequest,
  config: Partial<RequestConfig<ImportTimesheetEntriesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = importTimesheetEntriesMutationRequestSchema.parse(data);
  const res = await request<
    ImportTimesheetEntriesMutationResponse,
    ResponseErrorConfig<Error>,
    ImportTimesheetEntriesMutationRequest
  >({
    method: 'POST',
    url: `/api/entries/import`,
    data: requestData,
    ...requestConfig,
  });
  return importTimesheetEntriesMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/entries/import}
 */
export function useImportTimesheetEntries<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ImportTimesheetEntriesMutationResponse,
      ResponseErrorConfig<Error>,
      { data: ImportTimesheetEntriesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<ImportTimesheetEntriesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? importTimesheetEntriesMutationKey();

  return useMutation<
    ImportTimesheetEntriesMutationResponse,
    ResponseErrorConfig<Error>,
    { data: ImportTimesheetEntriesMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return importTimesheetEntries(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
